import React from 'react';
import HeroSection from '../components/HeroSection';
import OurOrganicFarms from '../components/OurOrganicFarms'; 
import OrganicJourney from '../components/OrganicJourney';   
import Services from './Services'; 
import WhyUs from './WhyUs'; 
import Footer from '../components/Footer';

function Home() {
  return (
    <div className="home-page-layout">
      {/* 1. Hero Banner Section */}
      <HeroSection />
      
      {/* 2. Photo Gallery Section (8 Images) */}
      <OurOrganicFarms />
      
      {/* 3. Video Grid Section (3 Videos) */}
      <OrganicJourney />
      
      {/* 4. Extra Content Sections */}
      <Services />
      <WhyUs />
      
      {/* 5. Footer */}
      <Footer />
    </div>
  );
}

export default Home;